<template>
  <div class="mention-list">
    <template v-if="items.length">
      <button v-for="(item, index) in items" :key="item.id" class="mention-item" :class="{ 'is-selected': index === selectedIndex }" @click="selectItem(index)">
        <img v-if="item.image" :src="item.image" alt="" class="mention-avatar" />
        <div v-else class="mention-avatar-fallback">
          {{ item.title.charAt(0).toUpperCase() }}
        </div>

        <div class="mention-text">
          <span class="mention-title">{{ item.title }}</span>
          <span v-if="item.subtitle" class="mention-subtitle">{{ item.subtitle }}</span>
        </div>
      </button>
    </template>
    <div v-else class="mention-empty">
      Nenhum resultado
    </div>
  </div>
</template>

<script>
export default {
  name: 'MentionList',
  props: {
    items: {
      type: Array,
      required: true
    },
    command: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      selectedIndex: 0
    }
  },
  watch: {
    items() {
      this.selectedIndex = 0;
    }
  },
  methods: {
    selectItem(index) {
      const item = this.items[index];
      if (item) {
        this.command({ id: item.id, label: item.title });
      }
    },
    onKeyDown({ event }) {
      if (event.key === 'ArrowUp') {
        this.selectedIndex = ((this.selectedIndex + this.items.length) - 1) % this.items.length;
        return true;
      }
      if (event.key === 'ArrowDown') {
        this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
        return true;
      }
      if (event.key === 'Enter') {
        this.selectItem(this.selectedIndex);
        return true;
      }
      return false;
    }
  }
}
</script>

<style scoped>
.mention-list {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  overflow: hidden;
  min-width: 200px;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  padding: 4px;
  z-index: 9999;
}

.mention-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 12px;
  text-align: left;
  font-size: 14px;
  border-radius: 6px;
  transition: background-color 0.15s;
  gap: 12px;
  outline: none;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #374151;
}

.mention-item:hover,
.mention-item.is-selected {
  background-color: #edfcf3;
  color: var(--primary, #0b9055);
}

.mention-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  background-color: #e5e7eb;
  border: 1px solid #f3f4f6;
  flex-shrink: 0;
}

.mention-avatar-fallback {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #edfcf3;
  color: var(--primary, #0b9055);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
}

.mention-text {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  line-height: 1.2;
}

.mention-title {
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mention-subtitle {
  font-size: 11px;
  color: #9ca3af;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
}

.mention-empty {
  padding: 8px 12px;
  font-size: 14px;
  color: #9ca3af;
  font-style: italic;
  text-align: center;
}
</style>
